[
  {
    "id": "sila",
    "name": "Siła",
    "description": "+5% obrażeń na rangę.",
    "branch": "atak",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 5,
    "cost": {
      "base": 80,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ]
  },
  {
    "id": "precyzja",
    "name": "Precyzja",
    "description": "+2% szansy na trafienie krytyczne na rangę.",
    "branch": "atak",
    "row": 1,
    "col": 0,
    "requires": 3,
    "maxRank": 5,
    "cost": {
      "base": 120,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ],
    "after": "sila"
  },
  {
    "id": "szeroki-zamach",
    "name": "Szeroki Zamach",
    "description": "+4% zasięgu ciosów i fal na rangę.",
    "branch": "atak",
    "row": 1,
    "col": 2,
    "requires": 3,
    "maxRank": 3,
    "cost": {
      "base": 120,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.04
      }
    ],
    "after": "sila"
  },
  {
    "id": "szybkie-rece",
    "name": "Szybkie Ręce",
    "description": "−3% czasu odnowienia umiejętności na rangę.",
    "branch": "atak",
    "row": 2,
    "col": 1,
    "requires": 6,
    "maxRank": 5,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ],
    "after": "sila"
  },
  {
    "id": "okrutne-ciosy",
    "name": "Okrutne Ciosy",
    "description": "Trafienia krytyczne zadają +15 pkt. proc. więcej obrażeń na rangę.",
    "branch": "atak",
    "row": 3,
    "col": 0,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 260,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "critDamage",
        "op": "add",
        "value": 0.15
      }
    ],
    "after": "precyzja",
    "icon": "stat:critChance"
  },
  {
    "id": "dalekosieznosc",
    "name": "Dalekosiężność",
    "description": "+5% zasięgu pocisków i +3% obszaru na rangę.",
    "branch": "atak",
    "row": 3,
    "col": 2,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 260,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "range",
        "op": "mul",
        "value": 0.05
      },
      {
        "stat": "area",
        "op": "mul",
        "value": 0.03
      }
    ],
    "after": "szeroki-zamach"
  },
  {
    "id": "mistrzostwo-broni",
    "name": "Mistrzostwo Broni",
    "description": "+8% obrażeń na rangę.",
    "branch": "atak",
    "row": 4,
    "col": 1,
    "requires": 14,
    "maxRank": 3,
    "cost": {
      "base": 320,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.08
      }
    ],
    "after": "szybkie-rece"
  },
  {
    "id": "zimna-krew",
    "name": "Zimna Krew",
    "description": "+1,5% szansy na krytyk i +5 pkt. proc. obrażeń krytycznych na rangę.",
    "branch": "atak",
    "row": 5,
    "col": 0,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 420,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.015
      },
      {
        "stat": "critDamage",
        "op": "add",
        "value": 0.05
      }
    ],
    "after": "okrutne-ciosy",
    "icon": "upgrade:precyzja"
  },
  {
    "id": "furia",
    "name": "Furia",
    "description": "−3% czasu odnowienia i +3% obrażeń na rangę.",
    "branch": "atak",
    "row": 5,
    "col": 2,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 420,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.03
      }
    ],
    "after": "dalekosieznosc",
    "icon": "upgrade:szybkie-rece"
  },
  {
    "id": "ostateczny-cios",
    "name": "Ostateczny Cios",
    "description": "Zwieńczenie Ataku. Trafienie dobija zwykłych i elitarnych wrogów, którym zostało mniej niż 10% zdrowia. Na bossów nie działa.",
    "branch": "atak",
    "row": 6,
    "col": 1,
    "requires": 24,
    "maxRank": 1,
    "cost": {
      "base": 2400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "executeBelow",
        "op": "add",
        "value": 0.1
      }
    ],
    "after": "mistrzostwo-broni",
    "capstone": true,
    "icon": "upgrade:mistrzostwo-broni"
  },
  {
    "id": "wytrwalosc",
    "name": "Wytrwałość",
    "description": "+15 maks. zdrowia na rangę.",
    "branch": "obrona",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 5,
    "cost": {
      "base": 60,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 15
      }
    ]
  },
  {
    "id": "pancerz-przodkow",
    "name": "Pancerz Przodków",
    "description": "+4 pancerza na rangę.",
    "branch": "obrona",
    "row": 1,
    "col": 0,
    "requires": 3,
    "maxRank": 5,
    "cost": {
      "base": 120,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 4
      }
    ],
    "after": "wytrwalosc"
  },
  {
    "id": "odnowa-ducha",
    "name": "Odnowa Ducha",
    "description": "+0,2 regeneracji zdrowia na sekundę na rangę.",
    "branch": "obrona",
    "row": 1,
    "col": 2,
    "requires": 3,
    "maxRank": 3,
    "cost": {
      "base": 120,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 0.2
      }
    ],
    "after": "wytrwalosc"
  },
  {
    "id": "szybkie-nogi",
    "name": "Szybkie Nogi",
    "description": "+3% szybkości ruchu na rangę.",
    "branch": "obrona",
    "row": 2,
    "col": 1,
    "requires": 6,
    "maxRank": 3,
    "cost": {
      "base": 160,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ],
    "after": "wytrwalosc"
  },
  {
    "id": "kolczasta-zbroja",
    "name": "Kolczasta Zbroja",
    "description": "Wrogowie, którzy cię dotykają, dostają 5 obrażeń na sekundę na rangę.",
    "branch": "obrona",
    "row": 3,
    "col": 0,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 240,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "thorns",
        "op": "add",
        "value": 5
      }
    ],
    "after": "pancerz-przodkow",
    "icon": "upgrade:pancerz-przodkow"
  },
  {
    "id": "zwinnosc",
    "name": "Zwinność",
    "description": "+3% szansy na uniknięcie pocisku, ciosu albo wybuchu na rangę.",
    "branch": "obrona",
    "row": 3,
    "col": 2,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 260,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "dodgeChance",
        "op": "add",
        "value": 0.03
      }
    ],
    "after": "odnowa-ducha",
    "icon": "stat:moveSpeed"
  },
  {
    "id": "kamienna-skora",
    "name": "Kamienna Skóra",
    "description": "+8% maks. zdrowia na rangę.",
    "branch": "obrona",
    "row": 4,
    "col": 1,
    "requires": 14,
    "maxRank": 3,
    "cost": {
      "base": 300,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "mul",
        "value": 0.08
      }
    ],
    "after": "szybkie-nogi"
  },
  {
    "id": "zywotnosc-lowcy",
    "name": "Żywotność Łowcy",
    "description": "+0,4 zdrowia za każde zabójstwo na rangę.",
    "branch": "obrona",
    "row": 5,
    "col": 0,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "lifeOnKill",
        "op": "add",
        "value": 0.4
      }
    ],
    "after": "kolczasta-zbroja",
    "icon": "stat:regen"
  },
  {
    "id": "twarda-skora",
    "name": "Twarda Skóra",
    "description": "+25 maks. zdrowia i +2 pancerza na rangę.",
    "branch": "obrona",
    "row": 5,
    "col": 2,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 25
      },
      {
        "stat": "armor",
        "op": "add",
        "value": 2
      }
    ],
    "after": "zwinnosc",
    "icon": "upgrade:wytrwalosc"
  },
  {
    "id": "bariera-przodkow",
    "name": "Bariera Przodków",
    "description": "Zwieńczenie Obrony. Tarcza pochłania obrażenia równe 25% maks. zdrowia i odnawia się 6 s po ostatnim ciosie.",
    "branch": "obrona",
    "row": 6,
    "col": 1,
    "requires": 24,
    "maxRank": 1,
    "cost": {
      "base": 2400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "barrier",
        "op": "add",
        "value": 0.25
      }
    ],
    "after": "kamienna-skora",
    "capstone": true,
    "icon": "upgrade:kamienna-skora"
  },
  {
    "id": "chciwosc",
    "name": "Chciwość",
    "description": "+10% złota z wypraw na rangę.",
    "branch": "fortuna",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 5,
    "cost": {
      "base": 90,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "goldGain",
        "op": "mul",
        "value": 0.1
      }
    ]
  },
  {
    "id": "madrosc",
    "name": "Mądrość",
    "description": "+8% doświadczenia na rangę.",
    "branch": "fortuna",
    "row": 1,
    "col": 0,
    "requires": 3,
    "maxRank": 5,
    "cost": {
      "base": 120,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "xpGain",
        "op": "mul",
        "value": 0.08
      }
    ],
    "after": "chciwosc"
  },
  {
    "id": "magnes",
    "name": "Magnes",
    "description": "+15% zasięgu zbierania na rangę.",
    "branch": "fortuna",
    "row": 1,
    "col": 2,
    "requires": 3,
    "maxRank": 3,
    "cost": {
      "base": 100,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.15
      }
    ],
    "after": "chciwosc"
  },
  {
    "id": "lowca-skarbow",
    "name": "Łowca Skarbów",
    "description": "Skrzynie pojawiają się o 12% częściej na rangę.",
    "branch": "fortuna",
    "row": 2,
    "col": 1,
    "requires": 6,
    "maxRank": 3,
    "cost": {
      "base": 200,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "chestRate",
        "op": "mul",
        "value": 0.12
      }
    ],
    "after": "chciwosc"
  },
  {
    "id": "ksiegi-mistrzow",
    "name": "Księgi Mistrzów",
    "description": "+6% doświadczenia na rangę.",
    "branch": "fortuna",
    "row": 3,
    "col": 0,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 260,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "xpGain",
        "op": "mul",
        "value": 0.06
      }
    ],
    "after": "madrosc",
    "icon": "upgrade:madrosc"
  },
  {
    "id": "szczesliwa-reka",
    "name": "Szczęśliwa Ręka",
    "description": "Przedmioty wyprawy wypadają o 15% częściej na rangę.",
    "branch": "fortuna",
    "row": 3,
    "col": 2,
    "requires": 10,
    "maxRank": 3,
    "cost": {
      "base": 260,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "relicFind",
        "op": "mul",
        "value": 0.15
      }
    ],
    "after": "magnes",
    "icon": "stat:chestRate"
  },
  {
    "id": "zloty-dotyk",
    "name": "Złoty Dotyk",
    "description": "+15% złota z wypraw na rangę.",
    "branch": "fortuna",
    "row": 4,
    "col": 1,
    "requires": 14,
    "maxRank": 3,
    "cost": {
      "base": 320,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "goldGain",
        "op": "mul",
        "value": 0.15
      }
    ],
    "after": "lowca-skarbow"
  },
  {
    "id": "blogoslawienstwo-losu",
    "name": "Błogosławieństwo Losu",
    "description": "Przedmioty wyprawy częściej są rzadsze (szczęście +20% na rangę).",
    "branch": "fortuna",
    "row": 5,
    "col": 0,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "luck",
        "op": "add",
        "value": 0.2
      }
    ],
    "after": "ksiegi-mistrzow",
    "icon": "upgrade:lowca-skarbow"
  },
  {
    "id": "pelna-sakwa",
    "name": "Pełna Sakwa",
    "description": "+10% złota z wypraw na rangę.",
    "branch": "fortuna",
    "row": 5,
    "col": 2,
    "requires": 18,
    "maxRank": 3,
    "cost": {
      "base": 400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "goldGain",
        "op": "mul",
        "value": 0.1
      }
    ],
    "after": "szczesliwa-reka",
    "icon": "upgrade:chciwosc"
  },
  {
    "id": "skarbiec-pustkowi",
    "name": "Skarbiec Pustkowi",
    "description": "Zwieńczenie Fortuny. Skrzynie pojawiają się o 30% częściej, a przedmioty wyprawy wypadają o połowę częściej.",
    "branch": "fortuna",
    "row": 6,
    "col": 1,
    "requires": 24,
    "maxRank": 1,
    "cost": {
      "base": 2400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "chestRate",
        "op": "mul",
        "value": 0.3
      },
      {
        "stat": "relicFind",
        "op": "mul",
        "value": 0.5
      }
    ],
    "after": "zloty-dotyk",
    "capstone": true,
    "icon": "upgrade:zloty-dotyk"
  },
  {
    "id": "szkola-rycerska",
    "name": "Szkoła Rycerska",
    "description": "+3 pancerza na rangę.",
    "branch": "klasa",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 3,
    "cost": {
      "base": 100,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 3
      }
    ],
    "classes": [
      "straznik"
    ],
    "icon": "stat:armor"
  },
  {
    "id": "tarczownik",
    "name": "Tarczownik",
    "description": "Tarcza z 5% maks. zdrowia na rangę (odnawia się po chwili bez ciosów).",
    "branch": "klasa",
    "row": 1,
    "col": 0,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "barrier",
        "op": "add",
        "value": 0.05
      }
    ],
    "after": "szkola-rycerska",
    "classes": [
      "straznik"
    ],
    "icon": "upgrade:pancerz-przodkow"
  },
  {
    "id": "szeroki-luk",
    "name": "Szeroki Łuk",
    "description": "+5% obszaru ciosów na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 2,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.05
      }
    ],
    "after": "szkola-rycerska",
    "classes": [
      "straznik"
    ],
    "icon": "upgrade:szeroki-zamach"
  },
  {
    "id": "odwet",
    "name": "Odwet",
    "description": "Wrogowie przy tobie dostają 6 obrażeń na sekundę na rangę.",
    "branch": "klasa",
    "row": 2,
    "col": 1,
    "requires": 5,
    "maxRank": 3,
    "cost": {
      "base": 280,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "thorns",
        "op": "add",
        "value": 6
      }
    ],
    "after": "szkola-rycerska",
    "classes": [
      "straznik"
    ],
    "icon": "stat:armor"
  },
  {
    "id": "niezlomny",
    "name": "Niezłomny",
    "description": "Zwieńczenie Strażnika. +12% maks. zdrowia i +10% obrażeń.",
    "branch": "klasa",
    "row": 3,
    "col": 1,
    "requires": 8,
    "maxRank": 1,
    "cost": {
      "base": 1200,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "mul",
        "value": 0.12
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.1
      }
    ],
    "after": "odwet",
    "classes": [
      "straznik"
    ],
    "capstone": true,
    "icon": "upgrade:kamienna-skora"
  },
  {
    "id": "szal-bitewny",
    "name": "Szał Bitewny",
    "description": "+4% obrażeń na rangę.",
    "branch": "klasa",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 3,
    "cost": {
      "base": 100,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.04
      }
    ],
    "classes": [
      "barbarzynca"
    ],
    "icon": "stat:damage"
  },
  {
    "id": "krwiozerczosc",
    "name": "Krwiożerczość",
    "description": "+0,5 zdrowia za każde zabójstwo na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 0,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "lifeOnKill",
        "op": "add",
        "value": 0.5
      }
    ],
    "after": "szal-bitewny",
    "classes": [
      "barbarzynca"
    ],
    "icon": "stat:regen"
  },
  {
    "id": "wirujace-topory",
    "name": "Wirujące Topory",
    "description": "+6% obszaru ciosów na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 2,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.06
      }
    ],
    "after": "szal-bitewny",
    "classes": [
      "barbarzynca"
    ],
    "icon": "stat:area"
  },
  {
    "id": "gruba-skora",
    "name": "Gruba Skóra",
    "description": "+20 maks. zdrowia na rangę.",
    "branch": "klasa",
    "row": 2,
    "col": 1,
    "requires": 5,
    "maxRank": 3,
    "cost": {
      "base": 280,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      }
    ],
    "after": "szal-bitewny",
    "classes": [
      "barbarzynca"
    ],
    "icon": "stat:maxHealth"
  },
  {
    "id": "rzez",
    "name": "Rzeź",
    "description": "Zwieńczenie Barbarzyńcy. Dobija wrogów poniżej 6% zdrowia i daje +8% obrażeń.",
    "branch": "klasa",
    "row": 3,
    "col": 1,
    "requires": 8,
    "maxRank": 1,
    "cost": {
      "base": 1200,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "executeBelow",
        "op": "add",
        "value": 0.06
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.08
      }
    ],
    "after": "gruba-skora",
    "classes": [
      "barbarzynca"
    ],
    "capstone": true,
    "icon": "upgrade:mistrzostwo-broni"
  },
  {
    "id": "skupienie",
    "name": "Skupienie",
    "description": "−3% czasu odnowienia na rangę.",
    "branch": "klasa",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 3,
    "cost": {
      "base": 100,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.03
      }
    ],
    "classes": [
      "arkanista"
    ],
    "icon": "stat:cooldown"
  },
  {
    "id": "potega-arkanow",
    "name": "Potęga Arkanów",
    "description": "+5% obrażeń na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 0,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ],
    "after": "skupienie",
    "classes": [
      "arkanista"
    ],
    "icon": "stat:damage"
  },
  {
    "id": "szybkie-zaklecia",
    "name": "Szybkie Zaklęcia",
    "description": "+8% prędkości pocisków na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 2,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "projectileSpeed",
        "op": "mul",
        "value": 0.08
      }
    ],
    "after": "skupienie",
    "classes": [
      "arkanista"
    ],
    "icon": "stat:projectileSpeed"
  },
  {
    "id": "mistyczna-oslona",
    "name": "Mistyczna Osłona",
    "description": "Tarcza z 6% maks. zdrowia na rangę.",
    "branch": "klasa",
    "row": 2,
    "col": 1,
    "requires": 5,
    "maxRank": 3,
    "cost": {
      "base": 280,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "barrier",
        "op": "add",
        "value": 0.06
      }
    ],
    "after": "skupienie",
    "classes": [
      "arkanista"
    ],
    "icon": "stat:armor"
  },
  {
    "id": "rozszczepienie",
    "name": "Rozszczepienie",
    "description": "Zwieńczenie Arkanisty. +1 pocisk dla każdej umiejętności z pociskami.",
    "branch": "klasa",
    "row": 3,
    "col": 1,
    "requires": 8,
    "maxRank": 1,
    "cost": {
      "base": 1400,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "projectileCount",
        "op": "add",
        "value": 1
      }
    ],
    "after": "mistyczna-oslona",
    "classes": [
      "arkanista"
    ],
    "capstone": true,
    "icon": "stat:projectileCount"
  },
  {
    "id": "oko-sokola",
    "name": "Oko Sokoła",
    "description": "+2% szansy na krytyk na rangę.",
    "branch": "klasa",
    "row": 0,
    "col": 1,
    "requires": 0,
    "maxRank": 3,
    "cost": {
      "base": 100,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.02
      }
    ],
    "classes": [
      "tropiciel"
    ],
    "icon": "stat:critChance"
  },
  {
    "id": "zabojcza-celnosc",
    "name": "Zabójcza Celność",
    "description": "+15 pkt. proc. obrażeń krytycznych na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 0,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "critDamage",
        "op": "add",
        "value": 0.15
      }
    ],
    "after": "oko-sokola",
    "classes": [
      "tropiciel"
    ],
    "icon": "upgrade:precyzja"
  },
  {
    "id": "lekki-krok",
    "name": "Lekki Krok",
    "description": "+4% szybkości ruchu na rangę.",
    "branch": "klasa",
    "row": 1,
    "col": 2,
    "requires": 2,
    "maxRank": 3,
    "cost": {
      "base": 180,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.04
      }
    ],
    "after": "oko-sokola",
    "classes": [
      "tropiciel"
    ],
    "icon": "stat:moveSpeed"
  },
  {
    "id": "unik",
    "name": "Unik",
    "description": "+4% szansy na unik na rangę.",
    "branch": "klasa",
    "row": 2,
    "col": 1,
    "requires": 5,
    "maxRank": 3,
    "cost": {
      "base": 280,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "dodgeChance",
        "op": "add",
        "value": 0.04
      }
    ],
    "after": "oko-sokola",
    "classes": [
      "tropiciel"
    ],
    "icon": "upgrade:szybkie-nogi"
  },
  {
    "id": "przeszywajace-belty",
    "name": "Przeszywające Bełty",
    "description": "Zwieńczenie Tropiciela. Pociski przebijają o jednego wroga więcej, +6% obrażeń.",
    "branch": "klasa",
    "row": 3,
    "col": 1,
    "requires": 8,
    "maxRank": 1,
    "cost": {
      "base": 1200,
      "growth": 1.55
    },
    "modifiers": [
      {
        "stat": "pierce",
        "op": "add",
        "value": 1
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.06
      }
    ],
    "after": "unik",
    "classes": [
      "tropiciel"
    ],
    "capstone": true,
    "icon": "stat:pierce"
  }
]